// The placed Trivia Night set (registry `Furniture`): the big host screen and
// the host podium, each its own component so either can be swapped for a
// Blender GLB later. Table-local, floor origin.

import React from 'react';
import { TriviaHostScreen } from './TriviaHostScreen';
import { TriviaPodium } from './TriviaPodium';

export function TriviaSet() {
  return <><TriviaHostScreen /><TriviaPodium /></>;
}

export default TriviaSet;
